
import styled from '@emotion/styled'
import PrimaryButton from './button';
import { useNavigate } from "react-router-dom";

function Modal() {
    
    const Mod = styled.div`
    font-size: 1.2em;
    color: #fff;
    width: 100%;
    height: 100%;
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px 10%;
    text-align: center;
    top: 0;
    left: 0;
    z-index: 100;
    background-color: #111;

    & > a {
        color: #fff;
    }
`
    const navigate = useNavigate()
    

    return(
        <Mod>

            <h1>We've Moved Permanently!</h1>
            <div><i>Standup Shuffle</i> is now called <i>Meeting Shuffle.</i> <br /> It is now permanently hosted on <a href="https://supertacocat.com">supertacocat.com</a><br /><br /></div>
            <a href="https://supertacocat.com/shuffle">
                Continue to Super Taco Cat
            </a>


        </Mod>
    )
}

export default Modal;